shadow$provide[186] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Primitive:{enumerable:true, get:function() {
  return Primitive;
}}});
var Model = require("../model");
var require$threestrap_SLASH_src_SLASH_binder_DOT_js = require("threestrap/src/binder.js");
class Primitive {
  static initClass() {
    this.Node = Model.Node;
    this.Group = Model.Group;
    this.model = this.Node;
    this.defaults = null;
    this.traits = null;
    this.props = null;
    this.finals = null;
    this.freeform = false;
  }
  constructor(node, _context, helpers) {
    this.node = node;
    this._context = _context;
    this._renderables = this._context.renderables;
    this._attributes = this._context.attributes;
    this._shaders = this._context.shaders;
    this._overlays = this._context.overlays;
    this._animator = this._context.animator;
    this._types = this._attributes.types;
    this.node.controller = this;
    this.node.on("added", _event => this._added());
    this.node.on("removed", _event => this._removed());
    this.node.on("change", event => {
      if (this._root) {
        return this.change(event.changed, event.touched);
      }
    });
    this.reconfigure();
    this._get = this.node.get.bind(this.node);
    this._helpers = helpers(this, this.node.traits);
    this._handlers = {inherit:{}, listen:[], watch:[], compute:[]};
    this._root = this._parent = null;
    this.init();
  }
  is(trait) {
    return this.traits.hash[trait];
  }
  init() {
  }
  make() {
  }
  made() {
  }
  unmake(_rebuild) {
  }
  unmade() {
  }
  change(_changed, _touched, _init) {
  }
  refresh() {
    return this.change({}, {}, true);
  }
  rebuild() {
    if (this._root) {
      this._removed(true);
      return this._added();
    }
  }
  reconfigure(config) {
    if (config != null) {
      this.node.configure(config, this._attributes);
    }
    this.traits = this.node.traits;
    return this.props = this.node.props;
  }
  _added() {
    let e, left;
    this._parent = this.node.parent != null ? this.node.parent.controller : undefined;
    this._root = this.node.root != null ? this.node.root.controller : undefined;
    this.node.clock = (left = this._inherit("clock")) != null ? left : this._root;
    try {
      try {
        this.make();
        this.refresh();
        return this.made();
      } catch (error) {
        e = error;
        this.node.print("warn");
        console.error(e);
        throw e;
      }
    } catch (error1) {
      e = error1;
      try {
        return this._removed();
      } catch (error2) {
      }
    }
  }
  _removed(rebuild) {
    if (rebuild == null) {
      rebuild = false;
    }
    this.unmake(rebuild);
    this._unlisten();
    this._unattach();
    this._uncompute();
    this._root = null;
    this._parent = null;
    return this.unmade(rebuild);
  }
  _listen(object, type, method, self) {
    if (self == null) {
      self = this;
    }
    if (object instanceof Array) {
      for (const o of Array.from(object)) {
        return this.__listen(o, type, method, self);
      }
    }
    return this.__listen(object, type, method, self);
  }
  __listen(object, type, method, self) {
    if (self == null) {
      self = this;
    }
    if (typeof object === "string") {
      object = this._inherit(object);
    }
    if (object != null) {
      const handler = method.bind(self);
      handler.node = this.node;
      object.on(type, handler);
      this._handlers.listen.push([object, type, handler]);
    }
    return object;
  }
  _unlisten() {
    if (!this._handlers.listen.length) {
      return;
    }
    for (const [object, type, handler] of Array.from(this._handlers.listen)) {
      object.off(type, handler);
    }
    return this._handlers.listen = [];
  }
  _inherit(trait) {
    const cached = this._handlers.inherit[trait];
    if (cached !== undefined) {
      return cached;
    }
    return this._handlers.inherit[trait] = this._parent != null ? this._parent._find(trait != null ? trait : null) : undefined;
  }
  _find(trait) {
    if (this.is(trait)) {
      return this;
    }
    return this._parent != null ? this._parent._find(trait) : undefined;
  }
  _uninherit() {
    return this._handlers.inherit = {};
  }
  _attach(selector, trait, method, self, start, optional, multiple) {
    if (self == null) {
      self = this;
    }
    if (start == null) {
      start = this;
    }
    if (optional == null) {
      optional = false;
    }
    if (multiple == null) {
      multiple = false;
    }
    const filter = function(node) {
      if (node != null && Array.from(node.traits).includes(trait)) {
        return node;
      }
    };
    const map = node => node != null ? node.controller : undefined;
    const flatten = function(list) {
      if (list == null) {
        return list;
      }
      let out = [];
      for (const sub of Array.from(list)) {
        if (sub instanceof Array) {
          out = out.concat(sub);
        } else {
          out.push(sub);
        }
      }
      return out;
    };
    const resolve = selector => {
      let node, nodes;
      if (typeof selector === "object") {
        node = selector;
        if (node != null ? node._up : undefined) {
          selector = multiple ? node._targets : [node[0]];
          return selector;
        }
        if (node instanceof Array) {
          selector = multiple ? flatten(node.map(resolve)) : resolve(node[0]);
          return selector;
        }
        if (node instanceof Model.Node) {
          return [node];
        }
      } else if (typeof selector === "string" && selector[0] === "\x3c") {
        let match;
        let discard = 0;
        if (match = selector.match(/^<([0-9])+$/)) {
          discard = +match[1] - 1;
        }
        if (selector.match(/^<+$/)) {
          discard = +selector.length - 1;
        }
        nodes = [];
        let previous = start.node;
        while (previous) {
          const {parent} = previous;
          if (!parent) {
            break;
          }
          previous = parent.children[previous.index - 1];
          if (!previous && !nodes.length) {
            previous = parent;
          }
          node = null;
          if (filter(previous)) {
            node = previous;
          }
          if (node != null && discard-- <= 0) {
            nodes.push(node);
          }
          if (!multiple && nodes.length) {
            return nodes;
          }
        }
        if (multiple && nodes.length) {
          return nodes;
        }
      } else if (typeof selector === "string") {
        const watcher = method.bind(self);
        this._handlers.watch.push(watcher);
        const selection = this._root.watch(selector, watcher);
        if (!multiple) {
          if (filter(selection[0])) {
            node = selection[0];
          }
          if (node != null) {
            return [node];
          }
        } else {
          nodes = selection.filter(filter);
          if (nodes.length) {
            return nodes;
          }
        }
      }
      if (!optional) {
        console.warn(this.node.toMarkup());
        throw new Error(`${this.node.toString()} - Could not find ${trait} \`${selector}\``);
      }
      if (multiple) {
        return [];
      } else {
        return null;
      }
    };
    const nodes = flatten(resolve(selector));
    if (multiple) {
      if (nodes != null) {
        return nodes.map(map);
      } else {
        return null;
      }
    } else {
      if (nodes != null) {
        return map(nodes[0]);
      } else {
        return null;
      }
    }
  }
  _unattach() {
    if (!this._handlers.watch.length) {
      return;
    }
    for (const watcher of Array.from(this._handlers.watch)) {
      if (watcher != null) {
        watcher.unwatch();
      }
    }
    return this._handlers.watch = [];
  }
  _compute(key, expr) {
    this._handlers.compute.push(key);
    return this.node.bind(key, expr, true);
  }
  _uncompute() {
    if (!this._handlers.compute.length) {
      return;
    }
    for (const key of Array.from(this._handlers.compute)) {
      this.node.unbind(key, true);
    }
    return this._handlers.compute = [];
  }
}
Primitive.initClass();
require$threestrap_SLASH_src_SLASH_binder_DOT_js.Binder.apply(Primitive.prototype);

};